import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, Heading, Button, Divider, Image } from '@chakra-ui/react';
import { AiFillStar } from 'react-icons/ai';
import { HiOutlineCurrencyRupee } from 'react-icons/hi';
import { TiLocationOutline } from 'react-icons/ti';
import { HiOutlineLockClosed } from 'react-icons/hi';
import badge from '../Assets/Icons/badge.svg';
import growth from '../Assets/Icons/Growth.svg';
import HpIcon from '../Assets/Icons/HpLogo.png';
import { ReactComponent as YellowBadge } from '../Assets/Icons/Yellowbadge.svg';
import { ReactComponent as Brownbadge } from '../Assets/Icons/BrownBadge.svg';
import { ReactComponent as JarIcon } from '../Assets/Icons/JarLogo.svg';
import { ReactComponent as AdobeIcon } from '../Assets/Icons/AdobeLogo.svg';
import { useBreakpointValue } from '@chakra-ui/react';
import ModalTemplate from '../../common/ModalTemplate';
import { Link as RouterLink } from 'react-router-dom';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import { OpportunityType, useOpportunies } from '../../../hooks/V2/useOpportunies';
import { usePublishedItems } from '../../../hooks/V2/useCourse';
import { useAssessmentSubmission } from '../../../hooks/V2/useAssessmentSumbission';
import { useSelectedCourse } from '../../../context/SelectedCourseContext';
function OpportunitiesCards() {
	const { selectedCourse } = useSelectedCourse();
	const { data: publishedItems, refetch: refetchPublishedItems } = usePublishedItems(selectedCourse?.course?._id);
	const [assessmentPublishedItem, setAssessmentPublishedItem] = React.useState<any>();
	useEffect(() => {
		// filter first published item of type Roadmap
		if (!publishedItems) return;
		const assessment = publishedItems.find(item => item.entityType === 'Assessment');
		// @ts-ignore
		setAssessmentPublishedItem(assessment);
		console.log('assessment----', assessment);
	}, [publishedItems]);

	const [showTestWaitingModal, setShowTestWaitingModal] = useState(false);
	const { data: userAssessment } = useAssessmentSubmission(assessmentPublishedItem?._id || '');
	const { data: opportunities, isLoading: isOpportunitiesApiLoading } = useOpportunies();
	console.log('opportunities:', opportunities);
	const [activeOpportunity, setActiveOpportunity] = useState<OpportunityType | null>(null);

	const isMobile = useBreakpointValue({ base: true, md: false });
	return (
		<Box minH="full" bg={'#F2F6FF'} py="16px" pb="100px">
			<Box>
				{isMobile ? (
					<Text mx={'auto'} ml={6} textStyle={'body2'} fontSize={'14px'} mb={['2px', '1rem']}>
						Companies unlocked based on{' '}
						<Text color={'ms-prepleaf.500'} as={'span'}>
							your percentile{' '}
						</Text>{' '}
						and{' '}
						<Text color={'ms-prepleaf.500'} as={'span'}>
							badges collected.
						</Text>
					</Text>
				) : (
					<Heading mx={'auto'} ml={6} as={'h6'} fontSize={'14px'} mb={['0', '1rem']}>
						Companies unlocked based on{' '}
						<Text color={'ms-prepleaf.500'} as={'span'}>
							your percentile{' '}
						</Text>{' '}
						and{' '}
						<Text color={'ms-prepleaf.500'} as={'span'}>
							badges collected.
						</Text>
					</Heading>
				)}
				{isMobile ? (
					<Text mx={'auto'} ml={6} textStyle={'body1-md'} fontSize={'16px'}>
						Opportunities for You
					</Text>
				) : (
					<Heading mx={'auto'} ml={6} as={'h6'} fontSize={'16px'}>
						Opportunities for You
					</Heading>
				)}
			</Box>
			<Box bg={'#F2F6FF'} mx={'auto'} m={4} display={'flex'} flexWrap="wrap" gap={3}>
				{opportunities &&
					opportunities.map((opportunity, index) => (
						<Box bg={'white'} maxW={{ md: '361px' }} w={['100%', '100%']} borderRadius={'12px'} border={'1.7px solid'} borderColor={'ms-grey.200'}>
							<Box m={4} display={'flex'} justifyContent={'space-between'} mb={2}>
								<Box display={'flex'} gap={2} alignItems={'start'}>
									<Box
										display={'flex'}
										alignItems={'center'}
										justifyContent={'center'}
										borderRadius={'50%'}
										border={'1px solid #F3F2F2'}
										h="48px"
										w="48px"
										p="4px"
									>
										<Image src={opportunity.companyLogo} />
									</Box>
									<Box>
										<Heading as={'h5'} color={'ms-prepleaf.500'}>
											{opportunity.companyName}
										</Heading>
										<Text color={'ms-grey.600'} lineHeight={'24px'} textStyle={'body2-md'}>
											{opportunity.role}
										</Text>
										<Flex justifyContent={'space-between'} gap={4} w={'124%'}>
											<Flex alignItems={'center'} gap={1}>
												<HiOutlineCurrencyRupee style={{ color: '#85A9EF' }} />{' '}
												<Text textStyle={'body2-md'} color={'#0A0103'} fontSize={'12px'} lineHeight={'16px'} fontWeight={'500'} fontStyle={'normal'}>
													{opportunity.salaryRange}
												</Text>{' '}
											</Flex>
											<Flex alignItems={'center'} gap={1}>
												<TiLocationOutline style={{ color: '#85A9EF' }} />{' '}
												<Box textStyle={'body2-md'} color={'#0A0103'} fontSize={'12px'} lineHeight={'16px'} fontWeight={'500'} fontStyle={'normal'}>
													{opportunity.location}
													<Text as={'span'} color={'#C7C9D9'} ml="4px" mr="4px">
														•
													</Text>
													{opportunity.workType}
												</Box>
											</Flex>
										</Flex>
									</Box>
								</Box>

								<Box
									h={6}
									border={'1.8px solid rgba(228, 228, 235, 0.10)'}
									alignItems={'center'}
									bg={'#1F2A37'}
									color={'white'}
									p={'4px'}
									borderRadius={'4px'}
									display={'flex'}
									gap={'5px'}
								>
									<Box textStyle={'body2-md'}>{opportunity.rating}</Box>
									<AiFillStar style={{ color: '#E5B800' }} />
								</Box>
							</Box>
							<Divider orientation="horizontal" style={{ borderColor: '#F3F2F2' }} borderWidth="1px" />
							<Box display={'flex'} alignItems={'center'} p={3} justifyContent={'space-between'}>
								<Box>
									<Flex gap={1} alignItems={'center'}>
										<Image src={badge} h="14px" w="14px" />

										<Box display={'flex'} alignItems={'center'}>
											<Box display={'flex'} alignItems={'center'} gap={'4px'}>
												<Text textStyle={'caption'} fontFamily={'Open Sans'} fontSize={'12px'}>
													Badges required :
												</Text>
												{opportunity.badgesRequired.map((badge, badgeIndex) => (
													// <Flex gap={'4px'}>{badges}</Flex>
													<Image src={badge?.meta?.badgeIcon} alt="full" w="18px" h="18px" />
												))}
											</Box>
										</Box>
									</Flex>
									<Flex gap={1} alignItems={'center'}>
										<Image src={growth} h="14px" w="14px" rounded="100%" boxShadow="0px 1px 2px 0px #8852FC0F, 0px 4px 4px 0px #8852FC1A;" />

										<Box>
											<Flex alignItems={'center'} gap={'4px'} textStyle={'caption'} fontFamily={'Open Sans'}>
												<Text>Percentile required: </Text>
												<Text textStyle={'body2-md'} fontSize={'14px'}>
													{' '}
													{opportunity.pencentileRequired}%
												</Text>{' '}
											</Flex>
										</Box>
									</Flex>
								</Box>

								<Button
									variant={'block-lg'}
									bg={'ms-prepleaf.500'}
									color={'white'}
									letterSpacing={'1.25px'}
									lineHeight={'24px'}
									textTransform={'uppercase'}
									fontFamily={'Open Sans'}
									px={'16px'}
									py={'8px'}
									onClick={() => setActiveOpportunity(opportunity)}
								>
									Apply &nbsp;{+opportunity.pencentileRequired < 0 ? null : <HiOutlineLockClosed size={22} />}
								</Button>
							</Box>
						</Box>
					))}
			</Box>

			<ModalTemplate
				title={''}
				marginX={3}
				paddingY="10px"
				closeOnEsc={false}
				showCloseButtonIcon={true}
				isOpen={activeOpportunity ? true : false}
				onClose={() => setActiveOpportunity(null)}
			>
				<Box textAlign="center">
					<Box p="12px" bg="#F2F6FF" boxSize="68px" mx="auto" rounded="100px" color="#4358F6">
						<InfoOutlineIcon boxSize="45.5px" />
					</Box>
					<Text mt="16px" textStyle="h4" color="#4358F6">
						Not eligible to apply
					</Text>
					<Text textStyle="body1-md" mt="10px" color="#3B3435">
						Eligibility criteria to unlock this job opportunity.
					</Text>
					<Box mt="10px" textAlign="center" mx="auto" maxW="220px">
						<Box display="flex" flexWrap="wrap" alignItems="center">
							<Text textStyle="body2-md">Badges required : </Text>
							<Box ml="4px" gap="6px" display="flex" flexWrap="wrap" alignItems="center">
								{activeOpportunity?.badgesRequired.map((badge, badgeIndex) => (
									// <Flex gap={'4px'}>{badges}</Flex>
									<Image src={badge?.meta?.badgeIcon} alt="full" minW="26.099px" minH="28px" w="26.099px" h="28px" />
								))}
							</Box>
						</Box>
						<Box mt="10px" display="flex" flexWrap="wrap">
							<Text textStyle="body2-md">Percentile required : {activeOpportunity?.pencentileRequired}%</Text>
						</Box>
					</Box>

					<Button as={RouterLink} to="/dashboard" w="full" mt="16px" variant="primary" bg="#4358F6">
						start practicing
					</Button>
				</Box>
			</ModalTemplate>
		</Box>
	);
}

export default OpportunitiesCards;
